import React, { useMemo } from 'react';
import { useAudioContext } from '../providers/AudioProvider';
import {
    Dimensions,
    StyleSheet,
    Text,
    TouchableOpacity,
    View,
} from 'react-native';
import { useThemeSettings } from '../ThemeProvider';
import { CustomIcon } from './CustomIcon';
import { TrackedTouchable } from '../analytics/components';
import FadeImage from './FadeImage';
import AudioProgressBar from './AudioProgressBar';
import { useActiveArticle } from '../features/news-feed/hooks/useActiveArticle';
import CustomLinearGradient, { GRADIENT_TYPE } from './CustomLinearGradient';
import getGlobalStyles from '../globalStyles';
import { FULL_WIDTH } from '../shared/constants/dimension';
import { ROUTES } from '../shared/constants/routes';
import { useNavigation } from '@react-navigation/native';
import { useCollectionStore } from '../store/collectionStore';
import { getImageUri } from '../shared/helpers/utils';
import TourStep from './productTours/TourStep';
import { TOUR_TYPES } from '../store/useTourStore';
import { useSafeAreaInsets } from 'react-native-safe-area-context';


const { width } = Dimensions.get('window');
const formatRate = (value: number) => {
  return value % 1 !== 0 ? parseFloat(value.toFixed(1)) : value;
};

export default function MiniAudioPlayer({ }: {}) {
const { isPlaying, duration, position, togglePlayback, seekForward, seekTo, mode, setMode, rate,
            toggleRate } = useAudioContext();
                const { activeArticle: article } = useActiveArticle();
    const { selectedCollection } = useCollectionStore();
    const { theme } = useThemeSettings();
    const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
    const { activeArticle } = useActiveArticle();
    const navigation = useNavigation();

    const insets = useSafeAreaInsets();
    const onPlayerPress = () => {
        (navigation as any).navigate(ROUTES.RADIO_PLAYER, { articleId: activeArticle?.id, collectionId: selectedCollection?.id });
    }
    return (
        <CustomLinearGradient gradientType={GRADIENT_TYPE.MODAL} angle={90} style={[styles.miniPlayer, gStyles.fullWidth, { bottom: insets.bottom }]}>
            <TouchableOpacity style={[gStyles.centerRow, { width: FULL_WIDTH }]} onPress={onPlayerPress}>
                <FadeImage source={getImageUri(article?.image!)} style={{ width: 50, height: 50 }} />
                <View style={{ flexDirection: 'column', paddingHorizontal: 12, flex: 1 }}>
                    <Text style={{ fontSize: 12, color: theme?.colors?.primary, fontWeight: '600' }} >
                        {article?.title}
                    </Text>
                    <AudioProgressBar
                        position={position}
                        duration={duration}
                        onSeek={seekTo}
                    />
                </View>

                <View style={{ flexDirection: 'row', gap: 12 }}>
                    <TrackedTouchable context={{ cta: isPlaying ? "AUDIO_PLAY" : "AUDIO_PAUSE", article_id: activeArticle?.id }} style={[gStyles.buttonStyle, gStyles.buttonCircle]} onPress={togglePlayback}>
                        <CustomIcon size={16} icon={isPlaying ? 'pause' : 'play'} />
                    </TrackedTouchable>
                    <TrackedTouchable context={{ cta: "AUDIO_SPEED", rate }} style={[gStyles.buttonStyle, gStyles.buttonCircle]} onPress={toggleRate}>
                        <Text style={{ color: theme.colors.primary, fontSize: 11, minWidth: 24, textAlign: 'center' }}>
                            {`${formatRate(rate)}x`}
                        </Text>
                    </TrackedTouchable>
                    <TourStep order={1} type={TOUR_TYPES.RADIO_HOME}>
                        {/*  <TouchableOpacity id="audioToggle" onPress={() => { setMode(mode === 'gist' ? 'full_story' : 'gist') }}
                        style={[gStyles.buttonStyle, gStyles.buttonCircle]}>
                        <CustomIcon size={16} icon={mode} />
                    </TouchableOpacity> */}
                    </TourStep>
                </View>
            </TouchableOpacity>
        </CustomLinearGradient>
    );
}

const styles = StyleSheet.create({
    miniPlayer: {
        flexDirection: 'row',
        paddingTop: 12,
        paddingBottom: 8,
        paddingHorizontal: 8,
        marginBottom: 12,
        borderRadius: 8,
        position: 'absolute',
        alignSelf: 'center'
    },
    albumArt: {
        width: width - 200,
        height: width - 200,
        textAlign: 'center',
    },
});
